import { FeatherArrowUpRight } from "@subframe/core";
import type { ExcursionCardProps } from "@op/puck-types";
import { Dc_Excursion_Card } from "@op/sf-op";

export const ExcursionCard = ({
  excursion,
  scrollId,
  isMarginal,
  onClick,
}: ExcursionCardProps) => {
  return (
    <Dc_Excursion_Card
      id={scrollId}
      onClick={onClick}
      heading={excursion.title}
      subtitle={excursion.overline}
      isMarginal={isMarginal}
      iconSlot={
        <div className="flex flex-col items-end rounded-lg bg-neutral-100 px-2 py-2">
          <FeatherArrowUpRight />
        </div>
      }
    />
  );
};

export default ExcursionCard;
